import { useEffect, useState } from 'react';

import { toCandidateViewModel } from '@/adapters/candidate-adapter';
import type { Candidate } from '@/models/candidate';
import { getActiveCandidates } from '@/services/candidate-service';
import { useBrowserQueryCache } from '@/lib/query-cache/use-browser-query-cache';

type CandidatesState = {
  status: 'loading' | 'success' | 'error';
  candidates: Candidate[];
  error?: string;
};

export function useCandidates(): CandidatesState {
  const queryCache = useBrowserQueryCache();
  const [state, setState] = useState<CandidatesState>({
    status: 'loading',
    candidates: [],
  });

  useEffect(() => {
    let active = true;

    getActiveCandidates({ cache: queryCache })
      .then((docs) => {
        if (!active) {
          return;
        }

        setState({
          status: 'success',
          candidates: docs
            .map(toCandidateViewModel)
            .sort((left, right) => left.name.localeCompare(right.name, 'pt-BR')),
        });
      })
      .catch(() => {
        if (!active) {
          return;
        }

        setState({
          status: 'error',
          candidates: [],
          error: 'Não foi possível carregar os candidatos agora.',
        });
      });

    return () => {
      active = false;
    };
  }, [queryCache]);

  return state;
}
